import { ObjectMapper } from "json-object-mapper";
import { IModel } from "services/models/IModel";
import { Model } from "services/models/model";

export class MovementTypeModel
  extends Model
  implements IModel<MovementTypeModel> {
  name: string = "";
  foreignId: string = "";
  companyGroupId: string | undefined = undefined;

  static create(input: any): MovementTypeModel {
    return ObjectMapper.deserialize<MovementTypeModel>(
      MovementTypeModel,
      input
    );
  }
}
